import {CtModelRouteData} from "@ctsolution/ct-framework";

export const LeadPlaceRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("LeadPlace");
